import { createFileRoute } from "@tanstack/react-router";
import type * as React from "react";

import { ConsoleActionsPage, consoleCustomConnectorsQueryOptions } from "@/features/console";

export const Route = createFileRoute("/_authed/_modal/console/actions")({
  // Intent preload — warm the custom-connector list; per-connector actions are
  // fetched on selection inside the page.
  loader: ({ context: { queryClient } }) => {
    void queryClient.ensureQueryData(consoleCustomConnectorsQueryOptions());
  },
  component: ConsoleActionsRoute,
});

function ConsoleActionsRoute(): React.ReactElement {
  return <ConsoleActionsPage />;
}
